<div class="documents-list">
  <div ngbAccordion>
    <div
      ngbAccordionItem
      class="border border-0"
      [collapsed]="initialClosed"
    >
      <div
        ngbAccordionHeader
        class="documents-list-header"
      >
        <button
          ngbAccordionToggle
          type="button"
          class="documents-list-toggle w-100 p-0 d-flex justify-content-between align-items-center gap-16"
        >
          <div class="left">
            <span class="font-size-12 line-height-16 font-weight-bold">{{ label }}</span>

            <i
              class="ml-2 icon ic-info-circle-16"
              tooltipClass="tooltip-info"
              placement="top-left"
              [ngbTooltip]="tip"
              [hidden]="!tip"
            ></i>
          </div>

          <div class="right">
            <i class="mr-2 icon ic-chevron-down-20"></i>
          </div>
        </button>
      </div>


      <div ngbAccordionCollapse>
        <div
          ngbAccordionBody
          class="p-0 pt-2"
        >
          <div [hidden]="documents && documents.length">{{ noDocsPlaceholder }}</div>

          <ul class="documents-list list-unstyled mb-0 d-flex flex-column" [hidden]="!documents || !documents.length">
            @for (document of documents; track document.name) {
              <li [hidden]="!document">
                <app-file-label
                  [fileName]="document?.name ?? null"
                  [hideDeleteBtn]="hideDeleteBtn"
                  [hideDownloadBtn]="hideDownloadBtn"
                  (downloadFile)="onDownloadFile(document)"
                  (deleteFile)="onDeleteFile(document)"
                />
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
